import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { SEASONS } from '@app/entities/enums/manage-vacations/manage-vacations.enum';
import { ManageVacationsCriteria } from '@app/entities/models/manage-vacations/manage-vacations-criteria.model';
import {
  EmployeeObservations,
  SeasonCalendar,
  VacationsSeason
} from '@app/entities/models/manage-vacations/manage-vacations.model';
import {
  MotFactoryProposal,
  MotVacationsProposal
} from '@app/entities/models/manage-vacations/mot-manage-vacations.model';
import { TUserTypeCalendarProposal } from '@app/entities/types/manage-vacations.type';

export interface MotManageVacationsRepository {
  getProposals(): Observable<MotVacationsProposal>;
  getVacationsCriteria(): Observable<ManageVacationsCriteria>;
  getVacationsSeason(): Observable<VacationsSeason>;
  getSeasonCalendar(season: SEASONS): Observable<SeasonCalendar<TUserTypeCalendarProposal>>;
  createProposal(
    proposalData: MotVacationsProposal,
    storedProposals: MotFactoryProposal[],
    isSummerSeason: boolean
  ): Observable<MotVacationsProposal>;
  updateObservations(observations: EmployeeObservations): Observable<EmployeeObservations>;
}

export const MOT_MANAGE_VACATIONS_REPOSITORY = new InjectionToken<MotManageVacationsRepository>(
  'MOT_MANAGE_VACATIONS_REPOSITORY'
);
